export const parseCursor = (cursor: string | null | undefined): null | number =>
  cursor ? parseInt(window.atob(cursor), 10) : null;

export const getTotalPages = (totalCount: number, limit: number): number =>
  Math.max(Math.ceil(totalCount / limit) || 1);
